import Swiper, { Pagination } from 'swiper';

const bannersHandler = () => {
    const banners = document.querySelectorAll('.Banner__swiper-box');

    if (banners) {
        banners.forEach((el) => {
            // eslint-disable-next-line no-unused-vars
            const swiper = new Swiper(el, {
                modules: [Pagination],
                loop: true,
                pagination: {
                    el: '.Banner__pagination',
                    type: 'bullets',
                    bulletElement: 'button',
                    bulletClass: 'Banner__pagination__item',
                    bulletActiveClass: '--Is-active',
                    clickable: true,
                },
            });
        });
    }
};

export default bannersHandler;
